<script setup lang="ts">
import type { SlideshowState } from "@/composables"
import { Button, Icon } from "@/components/ui"
import { useTranslation } from "@/composables"

withDefaults(defineProps<{
  state?: SlideshowState
  isFullscreen?: boolean
}>(), {
  state: "IDLE",
  isFullscreen: false,
})

const emit = defineEmits<{
  previous: []
  next: []
  close: []
  play: []
  pause: []
  fullscreen: []
}>()

const { t } = useTranslation()
</script>

<template>
  <div class="z-50">
    <button
      class="fixed left-10 top-1/2 transform -translate-y-1/2 p-2 rounded-xl bg-black bg-opacity-15 z-50"
      :aria-label="t('slideshow.controls_previous')"
      data-test="slideshow-previous"
      @click="() => emit('previous')"
    >
      <Icon class="text-white hover:text-gray-400 rotate-90" icon="CircleChevronDown" />
    </button>
    <button
      class="fixed right-10 top-1/2 transform -translate-y-1/2 p-2 rounded-xl bg-black bg-opacity-15 z-50"
      :aria-label="t('slideshow.controls_next')"
      data-test="slideshow-next"
      @click="() => emit('next')"
    >
      <Icon class="text-white hover:text-gray-400 -rotate-90" icon="CircleChevronDown" />
    </button>
    <div class="flex gap-2 fixed top-10 right-10 z-50">
      <Button v-if="state === 'PLAYING'" prefix-icon="Pause" :aria-label="t('slideshow.controls_pause')" data-test="slideshow-pause" @click="() => emit('pause')" />
      <Button v-else prefix-icon="Play" :aria-label="t('slideshow.controls_play')" data-test="slideshow-play" @click="() => emit('play')" />
      <Button
        :prefix-icon="isFullscreen ? 'Minimize' : 'Fullscreen'"
        :aria-label="isFullscreen ? t('slideshow.controls_exit_fullscreen') : t('slideshow.controls_enter_fullscreen')"
        data-test="slideshow-fullscreen"
        @click="() => emit('fullscreen')"
      />
      <Button prefix-icon="Close" :aria-label="t('slideshow.controls_close')" data-test="slideshow-close" @click="() => emit('close')" />
    </div>
  </div>
</template>
